export default {
  a: "fa-solid fa-0",
  b: "fa-solid fa-1",
  c: "fa-solid fa-2",
  d: "fa-solid fa-3",
  e: "fa-solid fa-4",
  f: "fa-solid fa-5",
  g: "fa-solid fa-6",
  h: "fa-solid fa-7",
  i: "fa-solid fa-8",
  j: "fa-solid fa-9",
  k: "fa-solid fa-star",
  l: "fa-solid fa-arrow-left",
  m: "fa-solid fa-arrow-up",
  n: "fa-solid fa-arrow-down",
  o: "fa-solid fa-arrow-right",
  p: "fa-solid fa-infinity",
  q: "fa-solid fa-plus",
  r: "fa-solid fa-minus",
  s: "fa-solid fa-divide",
  t: "fa-solid fa-equals",
  u: "fa-solid fa-music",
  v: "fa-solid fa-play",
  w: "fa-solid fa-square-full",
  x: "fa-solid fa-heart",
  y: "fa-solid fa-face-smile"
}